import React from "react";
import { ArrowDownRight, ArrowUpRight, Pencil, Trash2 } from "lucide-react";

import { variacao } from "../lib/historico";
import { numero, reais } from "../lib/numeros";
import { emDuasMedidas, sigla } from "../lib/unidades";

function Variacao({ v }) {
  if (v == null) return <span className="text-[11px] text-muted-foreground">primeira compra</span>;
  if (Math.abs(v) < 1) return <span className="text-[11px] text-muted-foreground">na média</span>;
  const caro = v > 0;
  const Seta = caro ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${caro ? "text-amber-600 dark:text-amber-400" : "text-emerald-600 dark:text-emerald-400"}`}>
      <Seta className="w-3 h-3" />{numero(Math.abs(v), 1)}% {caro ? "acima" : "abaixo"} da média
    </span>
  );
}

// Uma linha dos itens da compra: quantidade nas duas medidas, preço por unidade de estoque e total.
export default function LinhaItemCompra({ item, ing, media, emEdicao, aoVer, aoEditar, aoRemover }) {
  const unit = ing?.unit || "un";
  const { principal, secundaria } = emDuasMedidas(ing, item.qtdEstoque);
  const precoEstoque = item.qtdEstoque > 0 ? item.total / item.qtdEstoque : 0;

  return (
    <li onClick={aoVer} data-e2e="item-compra"
      className={`px-4 py-3 cursor-pointer transition-colors ${emEdicao ? "bg-primary/10" : "hover:bg-muted/40"}`}>
      <div className="flex items-start justify-between gap-2">
        <p className="font-semibold leading-snug line-clamp-2 break-words min-w-0">{item.nome}</p>
        <span className="font-bold tabular-nums shrink-0">{reais(item.total)}</span>
      </div>
      <div className="mt-1 flex items-end justify-between gap-2">
        <div className="min-w-0">
          <p className="text-xs text-muted-foreground tabular-nums">
            {principal}{secundaria ? ` · ${secundaria}` : ""} · {reais(precoEstoque)}/{sigla(unit)}
          </p>
          <Variacao v={variacao(precoEstoque, media)} />
        </div>
        <span className="flex shrink-0">
          <button type="button" title="Corrigir item" aria-label={`Corrigir ${item.nome}`} onClick={(e) => { e.stopPropagation(); aoEditar(); }}
            className="h-8 w-8 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted"><Pencil className="w-3.5 h-3.5" /></button>
          <button type="button" title="Tirar da compra" aria-label={`Tirar ${item.nome}`} data-e2e="remover-item" onClick={(e) => { e.stopPropagation(); aoRemover(); }}
            className="h-8 w-8 rounded-md flex items-center justify-center text-muted-foreground hover:text-destructive hover:bg-destructive/10"><Trash2 className="w-3.5 h-3.5" /></button>
        </span>
      </div>
    </li>
  );
}
